import type { IVocalise } from './vocalise';
import { vocaliseSchema } from './vocalise';
import { actionCreator, Joi, objectSchemaOf } from '../helpers';

export const FINISH = 'VOCALISE/FINISH';

export interface IFinishAction {
  type: typeof FINISH;
  payload: IVocalise;
}

export const finishActionSchema = objectSchemaOf<IFinishAction>({
  type: Joi.string().required().valid(FINISH),
  payload: vocaliseSchema.required(),
});

export const finish = actionCreator({
  type: FINISH,
  schema: finishActionSchema,
});
